// extracted by mini-css-extract-plugin
export var button = "empty-messages-screen-module--button--Xn10T";
export var description = "empty-messages-screen-module--description--y77pY";
export var title = "empty-messages-screen-module--title--Puy9r";
export var wrapper = "empty-messages-screen-module--wrapper--Pc1EA";